import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, GlobeIcon, MailIcon, ShieldCheckIcon, SmartphoneIcon } from 'lucide-react';
import { costs, faqs, purchases } from '../data/closing';
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-21" data-mp="3pmbrfc9mo6zq">
        <div className="mx-auto max-w-3xl text-center" data-id="element-22" data-mp="3bsc8ilyzfzxk">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-primary-soft" aria-hidden="true" data-id="element-23" data-mp="3gjkibj485nb9" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-24" data-mp="31v6h1cmgi6wt">
            GARANTÍA 30 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-primary/40 p-7 sm:p-10" data-id="element-25" data-mp="36ust3iqjth41">
            
            <p className="mt-4 text-foreground-muted" data-id="element-26" data-mp="2svjcihyfkkzj">
              Abrís los volúmenes. Aplicás el material.
            </p>
            <p className="mt-4 text-foreground-muted" data-id="element-27" data-mp="2wv205lhmza62">
              Si en 30 días no es lo que esperabas:
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-primary-soft sm:text-4xl" data-id="element-28" data-mp="2asqnxovad8nu">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-29" data-mp="2poy32aru7jw9">sin formularios, sin explicaciones.</p>
          </div>
        </div>
      </section>

      <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-30" data-mp="2kotmyluucr6k">
        <div className="mx-auto max-w-3xl" data-id="element-31" data-mp="1x2dgdnmb3vz1">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-32" data-mp="1wz7mlv2qg5wz">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-33" data-mp="26rn7p19btam3">
            {faqs.map(({
            question,
            answer
          }, index) => {
            const panelId = `faq-panel-${index}`;
            return <div key={question} className="overflow-hidden rounded-xl border border-foreground/10 bg-surface" data-id="element-34" data-mp="1eaknrub5gcru" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold transition-colors duration-150 ease-out hover:text-primary-soft sm:text-lg" data-id="element-35" data-mp="19cj3j61zm7es">
                    <span data-id="element-36" data-mp="27t894fmcqk1s">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-primary-soft transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-37" data-mp="27u9vvhcqcuzc" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-38" data-mp="1k2mdjntjas8o">
                    {open === index && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-39" data-mp="1k2w3xcihr1ew">
                        <p className="border-t border-foreground/10 px-5 py-5 leading-relaxed text-foreground-muted" data-id="element-40" data-mp="tslz3582ppb1">
                          {answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-41" data-mp="f3fpcnbm0gow">
      <div className="mx-auto max-w-4xl" data-id="element-42" data-mp="b2e0n0fbjn16">
        <h2 className="text-center font-display text-3xl font-bold text-highlight sm:text-4xl" data-id="element-43" data-mp="b3fe1bjt4lm2">
          ⚖️ ¿CUÁNTO TE CUESTA SEGUIR IMPROVISANDO?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-line-strong" data-id="element-44" data-mp="13501opy7a5u">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-line-strong border-l-line-accent bg-surface-raised px-5 py-4 font-medium last:border-b-0" data-id="element-45" data-mp="3sbas9gwtoz9p">
              <span className="mr-2 text-danger-soft" aria-hidden="true" data-id="element-46" data-mp="1qiuy0od6kwzu">
                ×
              </span>
              {item}
            </p>)}
        </div>
        <div className="mt-10 text-center" data-id="element-47" data-mp="1yk3ofhdseotx">
          
          <p className="mt-3 font-display text-2xl font-bold text-primary-soft sm:text-3xl" data-id="element-48" data-mp="23j6tv2xoix2f">
            No necesitás más recetas. Necesitás un sistema.
          </p>
        </div>
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: number | undefined;
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => {
      window.clearInterval(timer);
      window.clearTimeout(hideTimer);
    };
  }, []);
  return <>
      <footer className="border-t border-foreground/10 bg-canvas px-4 py-12 text-center" data-id="element-49" data-mp="wvi3pv578atz">
        <span className="inline-block rounded-full border border-primary/25 bg-primary/10 px-3 py-1 text-sm font-semibold text-primary-soft" data-id="element-50" data-mp="10uifwut68f80">
          PACK COMIDAS RESUELTAS™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-foreground-muted" data-id="element-51" data-mp="d9gi5arwgum2">
          El sistema práctico para planificar, preparar, congelar y tener comidas listas para usar durante la semana.
        </p>
        
        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-foreground-subtle" data-id="element-52" data-mp="m7jsdaxfq4yk">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary-soft" href="mailto:soportebiomalivido@gmail.com" data-id="element-53" data-mp="114j85m2fx444">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-54" data-mp="19xmfdcmhskqb" />
            soportebiomalivido@gmail.com
          </a>
          <span className="inline-flex items-center gap-1.5" data-id="element-55" data-mp="15xm2vxiyejlw">
            <SmartphoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-56" data-mp="1jwc1jhlf8rcd" />
            @biomalivido
          </span>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary-soft" href="https://biomalivido.com" target="_blank" rel="noreferrer" data-id="element-57" data-mp="1eyjxxqbezgsc">
            <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-58" data-mp="glg2zd0mbpal" />
            biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-foreground-faintest" data-id="element-59" data-mp="ljzojcbauz2f">
          © PACK COMIDAS RESUELTAS™ 2026 — Todos los derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-60" data-mp="vaubkiwde2ox">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-5 left-5 z-50 max-w-72 rounded-xl border border-primary/30 bg-canvas p-4 shadow-2xl" aria-live="polite" data-id="element-61" data-mp="v9spljdtfvsf">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-primary-soft" data-id="element-62" data-mp="363yju65eo5bo">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-63" data-mp="3b2rnl6uw4hyn" />
              Compra verificada
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-64" data-mp="33js7ba2q76ji">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-foreground-muted" data-id="element-65" data-mp="2tse8l4ilmarf">
              compró Pack Comidas Resueltas™
            </p>
            <p className="mt-1 text-xs text-foreground-faint" data-id="element-66" data-mp="2ouchpxexl75e">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}